import { Status } from "@/types/containerTypes";
import { Signature } from "../signature";

export enum PROCEDURETYPE {
  PROCEDURE = 'PROCEDURE',
  TEMPLATE = 'TEMPLATE',
  RUN = 'RUN',
}

export enum ProcedureState {
  CREATED = 'CREATED',
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  INVALID = 'INVALID',
  INITIALIZED = 'INITIALIZED',
}

export interface ProcedureInstanceCreateParams {
  procedureType: PROCEDURETYPE;
  title: string;
  state?: ProcedureState;
  estimatedRunTime?: string;
  description?: string;
  orgId: string;  
  procedureTemplateId?: string;
  status?: Status;
  versionId?: string;
  sourceId?: string;
  localDesktopId?: string;
  projectId?: string;
}

export interface ProcedureInstanceBaseParams extends ProcedureInstanceCreateParams {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  viewedAt?: Date | string;
  state: ProcedureState;
  status: Status;
  description?: string;
  signature?: Signature;
}

export class ProcedureInstanceBase {
  id: string;
  procedureTemplateId?: string;
  state: ProcedureState;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  title: string;
  description?: string;
  viewedAt?: Date | string;
  status: Status;
  estimatedRunTime?: string;
  procedureType: PROCEDURETYPE;
  orgId: string;
  /** The procedure's org (its "orgId" column), under the name containers and other org-owned rows use. */
  propelOrgId: string;
  signature?: Signature;
  versionId?: string;
  sourceId?: string;
  localDesktopId?: string;
  projectId?: string;

  constructor(params: ProcedureInstanceBaseParams) {
    this.id = params.id;
    this.orgId = params.orgId;
    this.propelOrgId = params.orgId;
    this.procedureType = params.procedureType;
    this.procedureTemplateId = params.procedureTemplateId;
    this.updatedAt = params.updatedAt;
    this.createdAt = params.createdAt;
    this.title = params.title;
    this.viewedAt = params.viewedAt;
    this.state = params.state;
    this.status = params.status;
    this.description = params.description;
    this.estimatedRunTime = params.estimatedRunTime || '';
    this.signature = params.signature;
    this.versionId = params.versionId;
    this.sourceId = params.sourceId;
    this.localDesktopId = params.localDesktopId;
    this.projectId = params.projectId;
  }

  isProcedure(): boolean {
    return this.procedureType === PROCEDURETYPE.PROCEDURE;
  }

  isTemplate(): boolean {
    return this.procedureType === PROCEDURETYPE.TEMPLATE;
  }
}
